/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    export function meevoCurrencyReplaceFilter($locale: angular.ILocaleService, $filter: angular.IFilterService): angular.IFilterService {
        const filter = (input: any) => {
            if (!input) {
                return input;
            }
            let currencyFilter = $filter('meevoCurrency') as angular.IFilterCurrency;

            if (input.includes('{currency}')) {
                for (let value of (input.match(/\{currency\}([^\s]+)/g))) {
                    let unformatValue = value.toString();
                    let formatValue = currencyFilter(unformatValue.replace('{currency}', ''));
                    input = input.replace(unformatValue, formatValue);
                }; 
            }
            return input;
             
        };
        return filter;
    }

    meevoCurrencyReplaceFilter.$inject = ['$locale', '$filter'];

    angular.module("meevo.components.filters")
        .filter("meevoCurrencyReplace", meevoCurrencyReplaceFilter);
}
